import { useRouter } from 'next/router';
import { PrimaryCta } from '#components/cta/PrimaryCta';
export const Error = () => {
  const router = useRouter();
  return <section className="relative bg-[url('/assets/claim-koda/error-background.webp')] bg-cover">
      <div className="standard-wrapper flex min-h-screen items-center justify-center">
        <div className="z-[2] mx-auto pt-16 text-center md:pt-32">
          <p className="mb-6 font-body text-xs uppercase text-gray-light">Try Again</p>
          <h3 className="headline-4 mb-10 max-w-3xl text-center font-body uppercase">
            Something went wrong
          </h3>
          <PrimaryCta className="h-10 w-48 p-0 text-xs leading-10" onClick={() => router.reload()}>
            Back to home
          </PrimaryCta>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 top-0 z-1 w-full bg-gradient-to-b from-transparent to-black" />
    </section>;
};